module.exports = __webpack_public_path__ + "img/LTS_ACCA.fe951e9f.gif";